const PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID as string | undefined;
const GADS_ID = import.meta.env.VITE_GADS_ID as string | undefined;
// const isProduction = import.meta.env.VITE_ENV === 'Production';

export const initTracking = () => {
  // if (GADS_ID) {
  //   const script = document.createElement('script');
  //   script.async = true;
  //   script.src = `https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`;
  //   document.head.appendChild(script);
  // }

  if (typeof fbq === 'function' && PIXEL_ID) {
    fbq('init', PIXEL_ID);
  }

  // if (typeof gtag === 'function' && GADS_ID) {
  //   gtag('config', GADS_ID, {
  //     ...(!isProduction && { debug_mode: true }),
  //   });
  // }
};

export const trackStartTrial = () => {
  if (typeof fbq === 'function') fbq('track', 'StartTrial');
  if (typeof gtag === 'function' && GADS_ID) {
    gtag('event', 'conversion', { send_to: `${GADS_ID}/nmW5CIvo-5scEL7CppUC` });
  }
};
